import { render, staticRenderFns } from "./view-subscriber.vue?vue&type=template&id=2894f677&scoped=true"
import script from "./view-subscriber.vue?vue&type=script&lang=js"
export * from "./view-subscriber.vue?vue&type=script&lang=js"
import style0 from "./view-subscriber.vue?vue&type=style&index=0&id=2894f677&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2894f677",
  null
  
)

export default component.exports